import React from 'react'
import { Container, Row } from "react-bootstrap";
import Header from "../Header";
import Footer from "../Footer";
import { BsBuildings } from "react-icons/bs";
import { CiLocationOn } from "react-icons/ci";
import Button from 'react-bootstrap/Button';
import { useNavigate } from 'react-router-dom';
import {useLocation } from 'react-router-dom';
import { MdArrowBackIos } from "react-icons/md";
import Col from "react-bootstrap/Col";

function ReadMore() {
    const location = useLocation();
    const responsibility = location.state?.responsibility;
    console.log(responsibility);
    const navigate = useNavigate()

    const iconStyle = {
      border: "none",
      color: "black",
      fontSize: "20px", // Set the font size to adjust the height and width
      // marginLeft:'20px',
      marginRight: "5px", // Optional: Add some margin if needed
      cursor: "pointer", // Optional: Add cursor pointer for interaction
    };
    
    const captionStyle = {
        textAlign: "left",
        boxShadow: "0px 8px 16px rgba(0, 0, 0, 0.1)",
        borderRadius: "10px",
        backgroundColor: "white",
        padding: "2px",
        width:'1200px',
      }

      const buttonStyle = {
        margin:'5px',
        padding: "5px",
        fontSize: "15px",
        fontWeight: 600,
        marginTop:'10px'
      };

      const captionTextStyleCard = {
        fontSize: "1.2rem",
        color: "black",
        textAlign: "left",
        marginLeft:'50px',
        marginBottom:"20px",
      };

  return (
    <div>
        <Container fluid style={{ margin: 0, padding: 0, overflowY: "hidden" }}>
            
            <div>
                <Header title="home" />
            </div>

          {responsibility &&
            <div className="d-flex justify-content-center"  style={{marginTop:'50px', marginBottom:'50px'}}>
            <div className="card " style={captionStyle}>
                <div className="card-body">
                    <div><h3> {responsibility.Title} </h3></div>
                    <div ><BsBuildings style={{marginRight:'5px'}}/><span style={{marginRight:'10px'}}>{responsibility.CompanyName}</span><CiLocationOn style={{marginRight:'5px'}}/><span> {responsibility.Location}</span></div>
                    <div style={{marginTop:'20px'}}>
                    <Row className="d-flex justify-content-between align-items-center">
              <Col xs={12} sm={4} md={4} lg={4} xl={4}>
                <span
                  style={iconStyle}
                  onClick={() => {
                    navigate("/Vacancies");
                  }}
                >
                  {" "}
                  <MdArrowBackIos />{" "}
                </span>
              </Col>
              <Col xs={12} sm={4} md={4} lg={4} xl={4} style={{display:'flex', justifyContent:'end' }}>
                <Button  type="submit" size="lg" variant="primary" style={buttonStyle} onClick={() => { navigate(`/CandidateApply/${responsibility.JobCode}`)}}>&nbsp;&nbsp;&nbsp;&nbsp; Apply &nbsp;&nbsp;&nbsp;&nbsp;</Button>
              </Col>
              </Row>
              </div>
                </div>
                <hr/>
                <div style={captionTextStyleCard} dangerouslySetInnerHTML={{ __html: responsibility.Responsibility }} />
            </div>
        </div>
          }

            <div>
                <Footer/>
            </div>

        </Container>
    </div>
  )
}

export default ReadMore